import axios from 'axios';

import keycloak from '@/utils/keycloak';

const apiClient = axios.create({ withCredentials: true });

apiClient.interceptors.request.use((config) => {
  const url = (config.baseURL ?? '') + (config.url ?? '');
  const isAnswer = url.startsWith('/answer/') || url.includes('/answer/api/');
  config.headers = config.headers ?? {};

  if (isAnswer) {
    // Answer는 쿠키만 사용
    delete config.headers.Authorization;
    // 절대 URL로 바뀌지 않게 상대 경로 유지
    if ((config as any).baseURL) (config as any).baseURL = '';
  } else if (keycloak?.authenticated && keycloak?.token) {
    config.headers.Authorization = `Bearer ${keycloak.token}`;
  }
  return config;
});

export default apiClient;
